module.exports = __webpack_public_path__ + "static/media/CONSOLIDADO_DA.0de65ba5.pdf";